export const iconFontAwesomePunctuationSymbolsCheckDouble = (
	<i className="fa-solid fa-check-double"></i>
);
